import React, { Component } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import Preloader from "../../views/Preloader/Preloader";

import CheckData from '../../shared/CheckData';

import MisAulas from './MisAulas';

let statusUser = 0;
class MainMisAulas extends Component {
    state = {
        statusUser: 0,
    }

    constructor (props) {
        super (props);
        CheckData((resp) => {
            statusUser = parseInt(resp)
            this.setState ({
                statusUser: parseInt(resp)
            })
        });
    }

    contenido = () => {
        return (
            <Switch>
                <Route path="/prof_aulas/mis_aulas" component={ () => <MisAulas/> } />
                <Redirect to = "/prof_aulas/mis_aulas" />
            </Switch>
        )
    }

    render() { 
        switch (statusUser) {
            case 0:
                return(<Preloader/>) 
            case 1:
                return (<Redirect to="/perfil" />)
            case 2:
                return (<Redirect to="/perfil" />)
            case 3:
                return (this.contenido())
            case 4:
                return (<Redirect to="/perfil" />)
            default:
                return(<Preloader/>) 
        }
    }
}
 
export default MainMisAulas;


// WEBPACK FOOTER //
// ./src/views/ProfAulas/MainMisAulas.jsx